import * as React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({
  title,
  description,
  openDialog = false,
  btn1 = "Disagree",
  btn2 = "Agree",
  confirmBtnColor = "error",
  handleCloseDialog,
  handleConfirmDialog,
}) {
  return (
    <div>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>{btn1}</Button>
          <Button
            onClick={handleConfirmDialog}
            color={confirmBtnColor}
            variant="contained"
            disableElevation
            autoFocus
          >
            {btn2}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
